(function () {
  // Money formatter (works with most themes)
  function formatMoney(cents) {
    try {
      const format =
        (window.theme && (window.theme.moneyFormat || window.theme.money_format)) ||
        window.Shopify?.money_format ||
        "{{amount}} kr.";

      // Shopify.formatMoney exists in many themes
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, format);
      }

      // Fallback basic formatter for DKK-style
      const value = (cents / 100).toFixed(2).replace(".", ",");
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " kr.";
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Could not fetch /cart.js");
    return res.json();
  }

  function applyFix(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach((item) => {
      // key is the stable identifier that matches data-key in your markup
      const key = item.key;
      const el = document.querySelector(`.cart__item[data-key="${CSS.escape(key)}"]`);
      if (!el) return;

      const sale = item.final_line_price;
      let regular = item.original_line_price;

      // If discounts exist but original isn't higher, compute "before price" like checkout:
      // regular = sale + total_discount (total_discount is in cents)
      if (item.total_discount > 0 && regular <= sale) {
        regular = sale + item.total_discount;
      }

      // Update strikethrough (before price)
      const strike = el.querySelector(".cart__price--strikethrough");
      if (strike) {
        strike.textContent = formatMoney(regular);
      }

      // Update sale price (optional but keeps it consistent)
      const saleEl = el.querySelector(".cart__price.cart__discount");
      if (saleEl) {
        saleEl.textContent = formatMoney(sale);
      }
    });
  }

  let running = false;
  async function run() {
    if (running) return;
    running = true;
    try {
      const cart = await fetchCart();
      applyFix(cart);
    } catch (e) {
      // silent
    } finally {
      running = false;
    }
  }

  // Run once on load and whenever cart drawer DOM changes
  function observeCartDrawer() {
    const targets = [
      document.querySelector(".cart__drawer"),
      document.querySelector("#CartDrawer"),
      document.querySelector("[data-cart-drawer]"),
      document.body
    ].filter(Boolean);

    const obs = new MutationObserver(() => run());
    targets.forEach((t) => obs.observe(t, { childList: true, subtree: true }));
  }

  document.addEventListener("DOMContentLoaded", function () {
    observeCartDrawer();
    run();
  });

  // Also run after common theme events (some themes trigger these)
  document.addEventListener("cart:updated", run);
  document.addEventListener("ajaxProduct:added", run);
})();